import React from "react";
import { useNavigate } from "react-router-dom";
import { colors, fonts } from "../theme";
import { View, Text, Card, Press, ScreenHeader } from "../ui";
import { Icon } from "../Icon";
import { useI18n } from "../i18n";
import { useAppState } from "../state";

export default function Practice() {
  const navigate = useNavigate();
  const { tr } = useI18n();
  const { state, dueFlashcardIds } = useAppState();
  const due = dueFlashcardIds().length;

  const featured = { icon: "lightning", title: tr("dailyReview"), desc: tr("dailyReviewDesc"), go: () => navigate("/session?mode=daily") };
  const items = [
    { icon: "cards", color: colors.info, title: tr("flashcards"), desc: tr("flashcardsDesc"), badge: due ? String(due) : undefined, go: () => navigate("/flashcards") },
    { icon: "cap", color: colors.brandPrimary, title: tr("quickQuiz"), desc: tr("quickQuizDesc"), go: () => navigate("/session?mode=quick") },
    { icon: "scales", color: colors.warning, title: tr("realCases"), desc: tr("realCasesDesc"), go: () => navigate("/session?mode=cases") },
    { icon: "compass", color: colors.brandPrimary, title: tr("scenarioChallenge"), desc: tr("scenarioDesc"), go: () => navigate("/scenarios") },
    { icon: "search", color: colors.error, title: tr("spotMistake"), desc: tr("spotDesc"), go: () => navigate("/session?mode=spot") },
    { icon: "puzzle", color: colors.success, title: tr("matchIt"), desc: tr("matchDesc"), go: () => navigate("/match") },
    { icon: "sort", color: colors.info, title: tr("orderIt"), desc: tr("orderDesc"), go: () => navigate("/order") },
    { icon: "check-circle", color: colors.success, title: tr("trueFalse"), desc: tr("trueFalseDesc"), go: () => navigate("/session?mode=truefalse") },
    { icon: "warning", color: colors.warning, title: tr("myMistakes"), desc: tr("myMistakesDesc"), badge: state.mistakes.length ? String(state.mistakes.length) : undefined, go: () => navigate("/mistakes") },
    { icon: "trend", color: colors.error, title: tr("weakTopics"), desc: tr("weakTopicsDesc"), go: () => navigate("/weak") },
  ];

  return (
    <View style={{ flex: 1, backgroundColor: colors.surfaceSecondary }}>
      <ScreenHeader title={tr("practice")} big />
      <View style={{ padding: 20 }}>
        <Press testID="practice-daily" onClick={featured.go} style={{ marginBottom: 16 }}>
          <Card style={{ backgroundColor: colors.brandPrimary, border: `1px solid ${colors.brandPrimary}`, flexDirection: "row", alignItems: "center", gap: 16 }}>
            <View style={{ width: 52, height: 52, borderRadius: 16, backgroundColor: "rgba(255,255,255,0.18)", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
              <Icon name={featured.icon} size={26} color={colors.onBrandPrimary} weight="fill" />
            </View>
            <View style={{ flex: 1 }}>
              <Text style={{ fontWeight: fonts.bold, fontSize: 17, color: colors.onBrandPrimary }}>{featured.title}</Text>
              <Text style={{ fontWeight: fonts.regular, fontSize: 13, color: "rgba(255,255,255,0.85)" }}>{featured.desc}</Text>
            </View>
            <Icon name="arrow-right" size={22} color={colors.onBrandPrimary} weight="bold" />
          </Card>
        </Press>

        <View row style={{ flexWrap: "wrap", justifyContent: "space-between", gap: 14 }}>
          {items.map((it, i) => (
            <Press key={i} testID={`practice-${i}`} onClick={it.go} style={{ width: "47%" }}>
              <Card style={{ minHeight: 128, justifyContent: "space-between", padding: 14 }}>
                <View row style={{ justifyContent: "space-between", alignItems: "flex-start" }}>
                  <View style={{ width: 40, height: 40, borderRadius: 12, backgroundColor: colors.surfaceSecondary, alignItems: "center", justifyContent: "center" }}>
                    <Icon name={it.icon} size={22} color={it.color} weight="fill" />
                  </View>
                  {it.badge && (
                    <View style={{ minWidth: 22, height: 22, borderRadius: 11, padding: "0 6px", backgroundColor: colors.error, alignItems: "center", justifyContent: "center" }}>
                      <Text style={{ fontWeight: fonts.bold, fontSize: 11, color: colors.onError }}>{it.badge}</Text>
                    </View>
                  )}
                </View>
                <View>
                  <Text style={{ fontWeight: fonts.bold, fontSize: 15, color: colors.onSurface, marginTop: 10 }}>{it.title}</Text>
                  <Text numberOfLines={2} style={{ fontWeight: fonts.regular, fontSize: 12, color: colors.muted, marginTop: 2 }}>{it.desc}</Text>
                </View>
              </Card>
            </Press>
          ))}
        </View>
      </View>
    </View>
  );
}
